import PhotoForFacesHighlight from './PhotoForFacesHighlightContainer';

export default PhotoForFacesHighlight;
